import { z } from 'zod';

export const formSchema = z.object({
  ma_thue: z.string().min(1, 'Mã thuế là bắt buộc'),
  ten_thue: z.string().min(1, 'Tên thuế là bắt buộc'),
  ten_thue2: z.string().min(1, 'Tên thuế khác là bắt buộc'),
  thue_suat: z.coerce.number().min(0, 'Thuế suất không được âm').optional(),
  thue_suat_hddt: z.coerce.number().optional(),
  stt: z.coerce.number().min(0, 'Số thứ tự không được âm').optional(),
  loai_thue: z.coerce.number().optional(),
  status: z.coerce.number().optional(),
  nhom_thue: z.string().min(1, 'Nhóm thuế là bắt buộc'),
  tk_thue_dau_ra: z.string().min(1, 'Tài khoản thuế đầu ra là bắt buộc'),
  tk_thue_dau_vao: z.string().min(1, 'Tài khoản thuế đầu vào là bắt buộc'),
  tk_thue_dau_ra_duoc_gia: z.string().min(1, 'Tài khoản thuế đầu ra được giảm là bắt buộc'),
  tk_thue_dau_vao_duoc_gia: z.string().min(1, 'Tài khoản thuế đầu vào được giảm là bắt buộc')
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_thue: '',
  ten_thue: '',
  ten_thue2: '',
  thue_suat: 0,
  thue_suat_hddt: 0,
  stt: 0,
  loai_thue: 1,
  status: 1,
  nhom_thue: '',
  tk_thue_dau_ra: '',
  tk_thue_dau_vao: '',
  tk_thue_dau_ra_duoc_gia: '',
  tk_thue_dau_vao_duoc_gia: ''
};
